import { render, staticRenderFns } from "./SkillOfDecisionMakers.vue?vue&type=template&id=3315d7fa&"
import script from "./SkillOfDecisionMakers.vue?vue&type=script&lang=ts&"
export * from "./SkillOfDecisionMakers.vue?vue&type=script&lang=ts&"
import style0 from "./SkillOfDecisionMakers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports